import { format, parse } from 'date-fns';

import { parseTime } from '~/domain/shared/time-helpers';

export const formatEventTime = (time: Date) => format(time, 'h:mmaaa');

export const formatEventTimeRange = (startTimeRaw: string | null, endTimeRaw: string | null) => {
  if (!startTimeRaw || !endTimeRaw) return null;
  const startTime = formatEventTime(parseTime(startTimeRaw));
  const endTime = formatEventTime(parseTime(endTimeRaw));
  return `${startTime}\u2013${endTime}`;
};

export const formatEventDate = (date: string | null) => {
  const parsedEventDate = date ? parse(date, 'yyyy-MM-dd', new Date()) : null;
  return parsedEventDate ? format(parsedEventDate, 'EEEE, MMMM d, yyyy') : null;
};
